module.exports = {"attributes":{"width":"12","height":"8","viewBox":"0 0 12 8","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M5 5.3L9.6.7A1 1 0 0 1 11 2.1L5.7 7.4a1 1 0 0 1-1.4 0l-3-3.1a1 1 0 0 1 1.3-1.4L5 5.3z\" />"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/tick.svg
// module id = 1450
// module chunks = 0